module.exports = __webpack_public_path__ + "static/media/Group98.68d9ad79.png";